export default __webpack_public_path__ + "static/media/apple_black.059cb7d9.svg";